import {
    CATEGORY_CHANCES,
    CATEGORY_INFOS,
    CATEGORY_RISKS,
    CATEGORY_UPDATES
} from '@/model/post/categories'

export default {
    category: {
        [CATEGORY_CHANCES]: 'Chances',
        [CATEGORY_INFOS]: 'Info',
        [CATEGORY_RISKS]: 'Risks',
        [CATEGORY_UPDATES]: 'Updates'
    },
    choose: 'Select a trend'
}
